<template>
  <div class="loading-overlay">
    <!-- 跳动圆点加载动画 -->
    <div class="loading-dots">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgb(255, 255, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  flex-direction: column;
}

/* 跳动圆点的样式 */
.loading-dots {
  display: flex;
  justify-content: center;
  backface-visibility: hidden;
}

.loading-dots span {
  width: .5rem;
  height: .5rem;
  border-radius: 50%;
  margin: 0 2px;
  animation: bounce 1.5s cubic-bezier(0.645, 0.045, 0.355, 1) infinite;
  background-color: #000;
  opacity: 0;
}

.loading-dots span:nth-child(1) {
  animation-name: bounceDot1;
}

.loading-dots span:nth-child(2) {
  margin: 0 .125rem;
  animation-name: bounceDot2;
}

.loading-dots span:nth-child(3) {
  animation-name: bounceDot3;
}

/* 动画效果定义 */
@keyframes bounceDot1 {
  40% { opacity: .5; }
  80% { opacity: 0; }
}

@keyframes bounceDot2 {
  50% { opacity: .5; }
  90% { opacity: 0; }
}

@keyframes bounceDot3 {
  60% { opacity: .5; }
  100% { opacity: 0; }
}
</style>
